<div class="mobile-category-picker-content">
	<button mat-button class="menu-toggle" [matMenuTriggerFor]="categoryMenu">
		<h1>
			<span class="visually-hidden" i18n="@@AriaCategoryPickerLabel">Choose category, current: </span>
			@if (currentCategory$ | async; as category) {
				<span class="category-name">{{ category?.locale?.name | getText }}</span>
			} @else {
				<span class="category-name" i18n="@@MobileCategoryPickerAllProductsHeader">All Products</span>
			}
			<g-icon [icon]="icons.faCaretDown" class="caret"></g-icon>
		</h1>
	</button>
	<mat-menu #categoryMenu="matMenu" class="mobile-category-picker-menu">
		<button
			mat-menu-item
			[routerLink]="['/products']"
			routerLinkActive="active"
			i18n="@@MobileCategoryPickerAllProductsButton"
			>All Products</button
		>
		<nav class="category-container" *ngIf="categories">
			<ng-container
				*ngTemplateOutlet="mobileCategoryTmpl; context: { categories, depth: 0 }"
			></ng-container>
		</nav>
	</mat-menu>
</div>

<ng-template #mobileCategoryTmpl let-categories="categories" let-depth="depth">
	@for (category of categories; track category.id) {
		<button
			mat-menu-item
			class="depth-{{ depth }}"
			[ngClass]="{ 'is-hidden': category | isHiddenCategory: allCategories }"
			[routerLink]="['/category', category.id, category.slug]"
			routerLinkActive="active"
		>
			{{ category.locale.name | getText }}
			<span class="badge" i18n="@@CategoryHiddenBadge">Hidden</span>
		</button>
		@if (category.children?.length) {
			<ng-container
				*ngTemplateOutlet="
					mobileCategoryTmpl;
					context: { categories: category.children, depth: depth + 1 }
				"
			>
			</ng-container>
		}
	}
</ng-template>
